import { FOUNDER_PHOTO_SIZE, FOUNDERS, JOIN_COUNT } from '@/content/social-proof';
import { groupThousands } from '@/lib/format';
import { useLang, useT } from '@/lib/useLang';

/**
 * Des visages photo à la place des avatars dessinés, à la demande de Stephen
 * (01/10/2026). Ce sont des portraits synthétiques, repris de
 * `front-component/src/assets/profile-avatars/` : décoratifs (`aria-hidden`,
 * `alt` vide), ils ne sont ni nommés ni présentés comme des membres précis.
 */
const MEMBER_AVATARS = [1, 2, 3, 4, 5].map((n) => `/avatars/member-${n}.jpg`);

/**
 * L'équipe, comme sur une page d'agence : des visages, des noms, des rôles.
 * Seulement les deux fondateurs — aucun « membre de l'équipe » inventé — et, à
 * côté, la communauté réelle d'où viennent les réactions.
 */
export function Founders() {
  const t = useT();
  const lang = useLang();

  return (
    <section id="team" className="nz-team">
      <div className="nz-team__head">
        <div className="nz-eyebrow">{t.teamEyebrow}</div>
        <h2 className="nz-h2">{t.joinH2}</h2>
        <p className="nz-lead">{t.joinP}</p>
      </div>

      <div className="nz-team__grid">
        {FOUNDERS.map((founder) => (
          <figure className="nz-team__card" key={founder.name}>
            {/* `loading="lazy"` : la section est sous le pli sur tous les formats. */}
            <picture>
              <source srcSet={founder.photo.webp} type="image/webp" />
              <img
                src={founder.photo.fallback}
                alt={founder.name}
                width={FOUNDER_PHOTO_SIZE.width}
                height={FOUNDER_PHOTO_SIZE.height}
                loading="lazy"
                decoding="async"
              />
            </picture>
            <figcaption>
              <b>{founder.name}</b>
              <span>{founder.role[lang]}</span>
            </figcaption>
          </figure>
        ))}

        {/*
          Masqué tant qu'aucun nombre réel n'est déclaré — avatars compris :
          cinq pastilles « de gens » sans personne derrière racontent la même
          chose que la phrase. Voir `JOIN_COUNT` dans `social-proof.ts`.
        */}
        {JOIN_COUNT !== null ? (
          <div className="nz-team__community">
            <div className="nz-stack" aria-hidden="true">
              {MEMBER_AVATARS.map((src) => (
                <img key={src} src={src} alt="" width={40} height={40} loading="lazy" decoding="async" />
              ))}
            </div>
            <b className="nz-team__count">{groupThousands(JOIN_COUNT, lang === 'fr' ? '\u00a0' : ',')}+</b>
            <span>{t.joinCount}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
}
